import { render, staticRenderFns } from "./UsedCarItem.vue?vue&type=template&id=3189de70&scoped=true&"
import script from "./UsedCarItem.vue?vue&type=script&lang=js&"
export * from "./UsedCarItem.vue?vue&type=script&lang=js&"
import style0 from "./UsedCarItem.vue?vue&type=style&index=0&id=3189de70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3189de70",
  null
  
)

export default component.exports